module.exports = __webpack_public_path__ + "img/boy-flag.41702c8d.png";